import React from 'react'
import { Grid } from "@mui/material";

export default function CampaignApprovalRequestSummary(props) {


    return (
        <>
            <Grid container spacing={2} sx={{ p: 3 }}>
                <Grid
                    item
                    xs={12}
                    lg={12}
                    sx={{ mt: 1 }}
                >
                    <Grid container spacing={2}>
                        <Grid
                            item
                            xs={12}
                            lg={2}
                            sx={{ p: 1 }}
                        >
                            <strong>Approval Requested By</strong>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={10}
                            sx={{ p: 1 }}
                        >
                            <div className='sba-incentive-mng-text-wr'>

                                <strong>: </strong><p>  Mike Parott</p>
                            </div>

                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0.2 }}>
                        <Grid
                            item
                            xs={12}
                            lg={2}
                            sx={{ p: 1 }}
                        >
                            <strong>Approval Requested On</strong>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={10}
                            sx={{ p: 1 }}
                        >
                            <div className='sba-incentive-mng-text-wr'>
                                <strong>: </strong> <p> Mike Parott</p>
                            </div>

                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0.2 }}>
                        <Grid
                            item
                            xs={12}
                            lg={2}
                            sx={{ p: 1 }}
                        >
                            <strong>Approver Remarks</strong>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={10}
                            sx={{ p: 1 }}
                        >
                            <div className='sba-incentive-mng-text-wr'>
                                <strong>: </strong>
                                <p>  Text is also known as 'fill text'.
                                    It is said that song composers of the past used dummy texts
                                    It is said that song composers of the past used dummy texts a
                                    It is said that song composers of the past used dummy texts a
                                    It is said that song composers of the past used dummy texts a
                                    It is said that song composers of the past used dummy texts aas lyrics when writing melodies in order to have
                                </p></div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0.2 }}>
                        <Grid
                            item
                            xs={12}
                            lg={2}
                            sx={{ p: 1 }}
                        >
                            <strong>Approval Status</strong>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={10}
                            sx={{ p: 1 }}
                        >
                            <div className='sba-incentive-mng-text-wr'>
                                <strong>: </strong><p>Approved</p>  </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0.2 }}>
                        <Grid
                            item
                            xs={12}
                            lg={2}
                            sx={{ p: 1 }}
                        >
                            <strong>Acknowledged By</strong>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={10}
                            sx={{ p: 1 }}
                        >
                            <div className='sba-incentive-mng-text-wr'>
                                <strong>: </strong> <p>Mike Parott</p>
                            </div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0.2 }}>
                        <Grid
                            item
                            xs={12}
                            lg={2}
                            sx={{ p: 1 }}
                        >
                            <strong>Acknowledged On</strong>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={10}
                            sx={{ p: 1 }}
                        >
                            <div className='sba-incentive-mng-text-wr'>  <strong>: </strong> <p> Mike Parott </p></div>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} sx={{ mt: 0.2 }}>
                        <Grid
                            item
                            xs={12}
                            lg={2}
                            sx={{ p: 1 }}
                        >
                            <strong>Acknowledger Remarks</strong>
                        </Grid>
                        <Grid
                            item
                            xs={12}
                            lg={10}
                            sx={{ p: 1 }}

                        >
                            <div className='sba-incentive-mng-text-wr'> <strong>: </strong><p>  Text is also known as 'fill text'.
                                It is said that song composers of the past used dummy texts
                                It is said that song composers of the past used dummy texts a
                                It is said that song composers of the past used dummy texts a
                                It is said that song composers of the past used dummy texts a
                                It is said that song composers of the past used dummy texts aas lyrics when writing melodies in order to have
                            </p></div>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>




        </>
    )
}
